import { useAuthUserStore } from '@/app/stores/user';
import { ref } from 'vue';
import { PayControlKeyAvailabilityFragment } from '@/app/graphql/access-control/sdk.access-control';
import { getKeyAvailability } from '@/shared/services/access-control';

export function useKeyAvailability() {
  const { isContractPayControl, selectedUserContract } = useAuthUserStore();
  const keyAvailability = ref<PayControlKeyAvailabilityFragment>({
    available: !isContractPayControl,
    nonAvailableFor: [],
    orgReferenceId: selectedUserContract?.orgReferenceId || 0,
  });

  const fetchKeyAvailability = async () => {
    try {
      if (selectedUserContract && isContractPayControl) {
        keyAvailability.value = await getKeyAvailability(selectedUserContract.orgReferenceId);
      }
    } catch (e) {
      console.error(e);
    }
    return keyAvailability.value;
  };

  return {
    keyAvailability,
    fetchKeyAvailability,
  };
}
